import { useEffect, useState } from 'react';
import { useReducedMotion } from 'framer-motion';

/**
 * Decides whether the pinned "cinematic stage" can run.
 *
 * Deliberately generous: any ordinary laptop qualifies (13" MacBooks report
 * ~1440x760, Windows laptops ~1366x700). The stage itself no longer depends on
 * a lucky viewport — it measures its tallest scene and scales the frame down a
 * touch when needed, so nothing is ever clipped. This gate therefore only
 * separates "desktop reel" from "phone/tablet stack".
 */
export const useCinematicStage = ({
  minWidth = 1024,
  minHeight = 580,
} = {}) => {
  const reduce = useReducedMotion();
  const [roomy, setRoomy] = useState(false);

  useEffect(() => {
    const query = window.matchMedia(
      `(min-width: ${minWidth}px) and (min-height: ${minHeight}px)`,
    );
    const sync = () => setRoomy(query.matches);
    sync();
    query.addEventListener('change', sync);
    return () => query.removeEventListener('change', sync);
  }, [minWidth, minHeight]);

  return {
    /** true when the pinned choreography should run */
    enabled: roomy && !reduce,
    reduce: Boolean(reduce),
  };
};

export default useCinematicStage;
